export default __webpack_public_path__ + "static/coverImage-66eaac110e8e5dcf08c9486026578db6.jpeg";